module.exports = __webpack_public_path__ + "img/home_icon_8.d86c3ea3.png";